module.exports = __webpack_public_path__ + "static/img/reward_pc.bb6219d5.png";